module.exports = __webpack_public_path__ + "img/logo_entete.2b422c2d.png";